/**
 * GlobalView — ViewModeSwitch (§14.2, Phase 6)
 *
 * Visual preset switcher — connected to globeStore.
 * Presets: Standard, CRT, NVG, FLIR.
 * Presets are shown as "active, visually prominent controls"
 * — not hidden in settings (§14.2).
 */

import { useGlobeStore, type VisualMode } from '../../stores/globeStore';
import styles from './ViewModeSwitch.module.css';

const MODES: { id: VisualMode; label: string; icon: string }[] = [
  { id: 'standard', label: 'STD', icon: '◉' },
  { id: 'crt', label: 'CRT', icon: '▦' },
  { id: 'nvg', label: 'NVG', icon: '◎' },
  { id: 'flir', label: 'FLIR', icon: '◈' },
];

export default function ViewModeSwitch() {
  const active = useGlobeStore((s) => s.visualMode);
  const setVisualMode = useGlobeStore((s) => s.setVisualMode);

  return (
    <div className={styles.container} id="view-mode-switch">
      {MODES.map((mode) => (
        <button
          key={mode.id}
          className={`${styles.button} ${active === mode.id ? styles.active : ''} ${active === mode.id && mode.id !== 'standard' ? styles[mode.id] : ''}`}
          onClick={() => setVisualMode(mode.id)}
          title={`Visual Mode: ${mode.label}`}
          id={`view-mode-${mode.id}`}
        >
          <span className={styles.icon}>{mode.icon}</span>
          <span className={styles.label}>{mode.label}</span>
        </button>
      ))}
    </div>
  );
}
